const brand = {
  brandProfile: "פרופיל מותג",
  companyName: "שם החברה",
  uploadLogo: "העלה לוגו",
  removeLogo: "הסר לוגו",
  tagline: "חתימה דיגיטלית",
  brandColors: "צבעי מותג",
  primary: "ראשי",
  secondary: "משני",
  tertiary: "שלישי",
  brand: "מותג",
} as const;
export default brand;
